import { createLengthValidator } from '@futrli/shared-services';

const MAX_NAME_LENGTH = 100;

export const textFieldValidator = createLengthValidator(MAX_NAME_LENGTH);
